module.exports = require("prismjs/components/prism-java.js");